import {orderAccAssignList,batchOrderAccAssign,orderAccAssignDetail,removeOrderExcel} from 'api/orderAccAssign';
import Cookies from 'js-cookie';

const orderAccAssign = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        orderAccAssignList({commit},params) {
            return new Promise((resolve, reject) => {
                var account = params.account;
                var provider = params.provider;
                var psize = params.psize;
                var currentPage = params.currentPage;
                orderAccAssignList(account, provider, psize, currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchOrderAccAssign({commit},params) {
            return new Promise((resolve, reject) => {
                batchOrderAccAssign(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        orderAccAssignDetail({commit},params) {
            return new Promise((resolve, reject) => {
                var accountStart = params.accountStart;
                var accountEnd = params.accountEnd;
                var provider = params.provider;
                var account = params.account;
                var receiverName = params.receiverName;
                var status = params.status;
                var psize = params.psize;
                var currentPage = params.currentPage;
                orderAccAssignDetail(accountStart, accountEnd,provider,account,receiverName, status, psize, currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        removeOrderExcel({commit},params){
            return new Promise((resolve, reject) => {
                removeOrderExcel(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default orderAccAssign;



// WEBPACK FOOTER //
// ./src/store/modules/orderAccAssign.js